<template>
  <div class="state">
    <img class="icon" src="../../assets/img/icon-loading.png" />
    <div class="label">正在加载...</div>
  </div>
</template>

<script>
export default {
  props: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  text-align: center;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.icon {
  display: block;
  width: 40px;
  height: 40px;
  animation: rotate 1s linear infinite;
}

.label {
  margin-top: 12px;
  font-size: 14px;
  color: #333;
}
</style>
